import { Dispatch, SetStateAction } from 'react'

type ItemOptionSelectProps = {
  quantity: number
  setQuantity: Dispatch<SetStateAction<number>>
}

export const ItemNumberSelector = ({
  quantity,
  setQuantity,
}: ItemOptionSelectProps) => {
  return (
    <div className="number-selector">
      <div
        className="inline-flex items-center justify-between border border-gray-300 rounded-lg w-36 h-12 px-2"
        data-testid="ITOCounter"
      >
        <button
          type="button"
          className="flex items-center justify-center w-10 h-10 text-gray-700 disabled:text-gray-300 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
          onClick={() => {
            if (quantity <= 1) return
            setQuantity(quantity - 1)
          }}
          disabled={quantity <= 1}
          aria-label="数量を減らす"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path fill="currentColor" d="M18 11.35H6v1.301h12z" />
          </svg>
        </button>

        <span
          className="flex-1 text-center text-base font-normal text-black select-none"
          aria-label={`${quantity} - Items`}
        >
          {quantity}
        </span>

        <button
          type="button"
          className="flex items-center justify-center w-10 h-10 text-gray-900 hover:bg-gray-50 transition-colors"
          onClick={() => {
            setQuantity(quantity + 1)
          }}
          aria-label="数量を増やす"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M12.65 18h-1.3v-5.35H6v-1.3h5.35V6h1.3v5.35H18v1.3h-5.35z"
            />
          </svg>
        </button>
      </div>
    </div>
  )
}
